module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_oita-9c7561417860d1d19424340783bd515b.png";